import { FormGenerator } from "../core/components/formGenerator";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import React from "react"
export default class Questions extends React.Component<any, any> {

    private _treeRef: kendo.ui.TreeView;


    private _setEmptyMarkers = (data: Array<any>, ds: kendo.data.ObservableArray) => {
        for (let i = 0; i < data.length; i++) {
            if (ds[i].empty !== data[i].empty) {
                ds[i].empty = data[i].empty;
                ds[i].trigger("change");
            }
            this._setEmptyMarkers(data[i].items, ds[i].items);
        }
    }

    componentDidMount() {
        //this._treeRef = $(this._treeElementRef).kendoTreeView({
        //    dataImageUrlField: "image",
        //    template: "<span class='reportTreeQuestion #= item.empty === true ? \"empty\":\"\"#'>#= item.text #</span>"
        //}).data("kendoTreeView");
        //this._treeRef.dataSource.data(this.props.context.treeDataSource);
        //$(this._treeElementRef).on("click", ".reportTreeQuestion", (e) => {
        //    const item = this._treeRef.dataItem(e.target);

        //    $(".reportActiveQuestion").removeClass("reportActiveQuestion");
        //    var $el = $("[data-model='entity.q" + item.id + "']");
        //    if (!$el[0]) {
        //        let cNode = item;
        //        while (!$el[0] && cNode["items"] && cNode["items"].length > 0) {
        //            $el = $("[data-model='entity.q" + cNode["items"][0].id + "']");
        //            cNode = cNode["items"][0];
        //        }
        //    }

        //    if ($el[0]) {
        //        $el[0].scrollIntoView();
        //        $el.addClass("reportActiveQuestion");
        //    }
        //});
    }
 

    componentDidUpdate() {
        //this._setEmptyMarkers(this.props.context.treeDataSource, this._treeRef.dataSource.data());
    }

    render() {
        const regionProps = $.extend({}, this.props, { regions: this.props.context.questionsRegion });
        return (
            <FullHeightContainer classes="flex-container--row">
                <FullHeightContainer classes='reporting-wrapper__fields-wrapper'>
                    <FormGenerator {...regionProps as any} />
                </FullHeightContainer>
            </FullHeightContainer>
        );
    }

}